import { useRef, useState } from 'react';
import { Form, useLoaderData } from 'react-router-dom';

import { WIZARD_COMPLETED } from '../../data/analytics';
import {
  Options,
  Question as QuestionData,
  Questions,
} from '../../data/wizard';
import Mixpanel from '../../mixpanel';
import Question from './components/Question';

import styles from './Wizard.module.css';

type SelectedOptions = {
  [key in Questions]: Options[];
};

const updateSelectedOptions = (
  state: SelectedOptions,
  question: Questions,
  option: Options,
  value: boolean
): SelectedOptions =>
  Object.assign({}, state, {
    [question]: value
      ? state[question].concat([option])
      : state[question].filter(o => o !== option),
  });

const Wizard = (): JSX.Element => {
  const questions = useLoaderData() as ReadonlyArray<QuestionData>;
  const ref = useRef<HTMLFormElement>(null);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState<SelectedOptions>({
    [Questions.Problems]: [],
    [Questions.Rooms]: [],
  });

  return (
    <div className={styles.container}>
      <Form className={styles.form} ref={ref} method="post">
        {questions.map((question, index) => (
          <Question
            key={question.id}
            question={question}
            isButtonDisabled={
              question.required && selectedOptions[question.id].length === 0
            }
            isVisible={questionIndex === index}
            onButtonClick={e => {
              if (questionIndex !== questions.length - 1) {
                // Display next question, prevent submit
                e.preventDefault();
                setQuestionIndex(index => index + 1);
              } else {
                // Submit the form
                Mixpanel.track(WIZARD_COMPLETED, selectedOptions);
              }
            }}
            onValueChanged={(option, value) =>
              setSelectedOptions(previousState =>
                updateSelectedOptions(previousState, question.id, option, value)
              )
            }
          />
        ))}
      </Form>
    </div>
  );
};

export default Wizard;
